/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyProjectType = {

	delete (context, contestTypeId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-project-type"
			+ "?contestTypeId=" + contestTypeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, onSuccess, onError, options) {
		Api.get(context,
			"/agency-project-type"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, contestType, onSuccess, onError, options) {
		Api.put(context,
			"/agency-project-type"
			, contestType
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
